var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-modal',{attrs:{"show":_vm.show,"modal-class":_vm.bannerClass,"visible":_vm.show,"hide-header":"","hide-footer":"","size":"lg"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }